/* eslint-disable import/no-cycle */
/* eslint-disable import/named */
/* eslint-disable import/prefer-default-export */
import Vuex from 'vuex';
import Vue from 'vue';

import { vehicleModule } from './modules/vehicle-store';
import { enquiryModule } from './modules/enquiry-store';
import { policyModule } from './modules/policy-store';
import { postEnquiryModule } from './modules/post-enquiry-store';
import { initialSettingsModule } from './modules/initial-settings-store';
import { addressModule } from './modules/address-store';
import { personalDetailsModule } from './modules/personal-details-store';
import { searchQueryModule } from './modules/search-query-store';
import { vehicleValuationModule } from './modules/vehicle-valuation-store';
import { financeSettlementModule } from './modules/finance-settlement-store';
import { vehicleSearchModule } from './modules/vehicle-search-store';
import { vehicleManagementModule } from './modules/vehicle-management-store';
import { financeModule } from './modules/finance-store';
import { businessModule } from './modules/business-store';
import { testDriveAvailabilityModule } from './modules/test-drive-availability-store';
import { retailerModule } from './modules/retailer-store';

Vue.use(Vuex);

export const store = new Vuex.Store({
  modules: {
    vehicleModule,
    vehicleSearchModule,
    enquiryModule,
    policyModule,
    postEnquiryModule,
    initialSettingsModule,
    addressModule,
    personalDetailsModule,
    searchQueryModule,
    vehicleValuationModule,
    financeSettlementModule,
    vehicleManagementModule,
    financeModule,
    businessModule,
    testDriveAvailabilityModule,
    retailerModule
  }
});
